import DraggableThumb from '../draggable_thumb_controller';

export default class extends DraggableThumb {
  static targets = ['image'];

  createGhostElement() {
    const element = document.createElement('img');
    element.src = this.imageTarget.src;

    return element;
  }

  addItem(itemProps) {
    itemProps['kind'] = 'visual-element';
    window.ed.featureActionsService.add('visual_element_added_to_canvas');
    return super.addItem(itemProps);
  }
}
